import { mask } from 'remask';

export function maskAge(value: string | undefined) {
  if (!value) return '';

  const cpf = ['9', '99'];

  return mask(value, cpf);
}
